module.exports = __webpack_public_path__ + "img/bg-magento-find-out_medium@2x.6456eb40.webp";